import {
	CREATE_RESTAURANT_RESERVATION_BEGIN,
	CREATE_RESTAURANT_RESERVATION_SUCCESS,
	CREATE_RESTAURANT_RESERVATION_ERROR,
} from '../actions/createRestaurantReservation'

import merge from 'lodash/merge'

const initialState = {
	confirmations: [],
	loading: false,
	error: null,
}

export default function createRestaurantReservationReducer(state = initialState, action) {
	switch(action.type) {
		case CREATE_RESTAURANT_RESERVATION_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case CREATE_RESTAURANT_RESERVATION_SUCCESS:
			return {
				...state,
				loading: false,
				confirmations: merge({}, state.confirmations, action.payload)
			}

		case CREATE_RESTAURANT_RESERVATION_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error
			}

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/createRestaurantReservationReducers.js